import { colors } from 'ui/theme/colors';
import { getColor } from 'ui/icons/utils';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const User16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M4.86665 5.24324C4.86665 6.99999 6.26665 8.48648 8.06665 8.48648C9.86665 8.48648 11.2667 7.06756 11.2667 5.24324C11.2667 3.41892 9.73332 2 7.99998 2C6.26665 2 4.86665 3.41892 4.86665 5.24324Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M8 9.09461C5.26667 9.09461 3 11.3919 3 14.1622C3 14.3649 3.13333 14.5 3.33333 14.5H12.6667C12.8667 14.5 13 14.3649 13 14.1622C13 11.3919 10.7333 9.09461 8 9.09461Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
